import { EntityVm } from 'api/core/entity.vm';
import { IsArray, IsEnum, IsString } from 'class-validator';

export enum ReceptionType {
  BY_SUPPLIER = 'BY_SUPPLIER',
  BY_ORDER = 'BY_ORDER',
}

export enum ReceptionStatus {
  CANCELED = 'CANCELED',
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  CLOSED_WITH_ERROR = 'CLOSED_WITH_ERROR',
  PENDING_INTEGRATION = 'PENDING_INTEGRATION',
}

export class ReceptionVm extends EntityVm {
  @IsString()
  supplierId: string;

  @IsString()
  orderId: string;

  @IsString()
  supplierName: string;

  @IsString()
  warehouseId: string;

  @IsEnum(ReceptionStatus)
  status: ReceptionStatus;

  @IsString()
  integrationError: string;

  @IsString()
  isActive: boolean;

  @IsString()
  type: ReceptionType;

  @IsString()
  thirdPartyReferenceDocument: string;

  @IsArray()
  generatedDocumentIds: string[];

  @IsString()
  receiverName?: string;
}
